import React, { useState, useEffect } from "react";
import { useOne, IResourceComponentsProps } from "@pankod/refine-core";
import { DescriptionItem } from "../../../components/text-layout/descriptionItem.text";

import {
    Show,
    Card,
    Row,
    Col,
    Space,
} from "@pankod/refine-antd";

import { urlPath } from "../../../utility/url";
import { ActivateDeactivateEbVaStatusModel } from "../../company/components/models/activate-deactivate-eb-va-status.model";
import { ActivateDeactivateDecentroVaStatusModel } from "../../company/components/models/activate-deactivate-decentro-va-status.model";
import { ToggleVirtualAccountOptionsModel } from "./components/model/toggle-virtual-account-options.model";
import BackTitle from "components/back-title";

export const VirtualAccountShow: React.FC<IResourceComponentsProps> = () => {
    let url = urlPath();
    let [refreshTableData, setRefreshTableData] = useState(false);

    let { data: tableProps, isLoading: vaTableLoading, refetch: refetchVaTableData } = useOne<any>({
        id: '',
        dataProviderName: "grapghQl",
        resource: 'getVirtualAccountById',
        metaData: {
            virtualAccountId: url.lastElement,
            tableRefresh: refreshTableData,
        },
        queryOptions: {
            enabled: true,
            onSuccess: () => {
                setRefreshTableData(false);
            },
        },
    });

    useEffect(() => {
        setRefreshTableData(false)
    }, [refreshTableData])

    const setTableRefetch = (message: boolean) => {
        setRefreshTableData(message);
    };

    let vaListing = tableProps?.data || {};
    let vaTableListingLabel = `${vaListing?.serviceProviderIntegration?.serviceProviderIntegrator?.name} - ${vaListing?.ifsc}`

    useEffect(() => {
        if (refreshTableData) {
            refetchVaTableData();
        }
    }, [refreshTableData]);

    return (
        <Show
            isLoading={vaTableLoading}
            title={<BackTitle title={vaTableListingLabel} />}
            headerButtons={({ defaultButtons }) => (
                <>
                    {
                        (tableProps?.data && vaListing.decentroVirtualAccount) && <ActivateDeactivateDecentroVaStatusModel bankAccountDetails={vaListing} setTableRefetch={setTableRefetch}/>
                    }
                    {
                        (tableProps?.data && !vaListing.decentroVirtualAccount) && <ActivateDeactivateEbVaStatusModel bankAccountDetails={vaListing} setTableRefetch={setTableRefetch}/>
                    }
                </>
            )}
        >
            <Row className="company-wrapper connected-full-height" gutter={[11, 11]}>
                <Col lg={12} md={12}>
                    <h2>Integrator Details</h2>
                    <Card size="small" className="h-100">
                        <Row>
                            <Col lg={16}>
                                <DescriptionItem title="Name" content={vaListing?.serviceProviderIntegration?.key} />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8}>
                                <DescriptionItem title="Upi Support" content={vaListing?.serviceProviderIntegration?.isQuickPayUpiSupported ? 'Enabled': 'Disabled'} />
                            </Col>
                            <Col lg={8}>
                                <DescriptionItem title="Bank Transfer Support" content={vaListing?.serviceProviderIntegration?.isQuickPayBankTransferSupported ? 'Enabled': 'Disabled'} />
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col lg={12} md={12}>
                    <h2>Bank Account Details</h2>
                    <Card size="small" className="h-100">
                        <Row>
                            <Col lg={12}>
                                <DescriptionItem title="Account No" content={vaListing?.accountNo} />
                            </Col>
                            <Col lg={4}>
                                <DescriptionItem title="Balance" content={vaListing?.balance} />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8}>
                                <DescriptionItem title="Upi Support" content={vaListing?.isPreferredForQuickPayUpi ? 'Enabled': 'Disabled'} />
                            </Col>
                            <Col lg={8}>
                                <DescriptionItem title="Bank Transfer Support" content={vaListing?.isPreferredForQuickPayBankTransfer ? 'Enabled': 'Disabled'} />
                            </Col>
                        </Row>
                        <Space direction="vertical">
                            {tableProps && <ToggleVirtualAccountOptionsModel setTableRefetch={setTableRefetch} tableProps={vaListing}/>}
                        </Space>
                    </Card>
                </Col>
            </Row>
        </Show>

    );
};
